<template>
    <div class="permissionAdd">
        <el-breadcrumb class="bread-nav" separator="/">
            <el-breadcrumb-item>首页</el-breadcrumb-item>
            <el-breadcrumb-item>权限管理</el-breadcrumb-item>
            <el-breadcrumb-item>添加权限</el-breadcrumb-item>
        </el-breadcrumb>
        <el-form :model="addPermissionForm" ref="addPermissionForm" :rules="validateRules" label-width="100px" class="addPermissionForm">
            <el-form-item label="权限名称" prop="permissionName">
                <el-input v-model="addPermissionForm.permissionName" placeholder="请填写权限名称"></el-input>
            </el-form-item>
            <el-form-item label="权限描述" prop="permissionContent">
                <el-input type="textarea" v-model="addPermissionForm.permissionContent" placeholder="请填写权限概述"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="addPermission('addPermissionForm')">立即创建</el-button>
                <el-button @click="clearPermissionData">重置</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>
<script>
import CONFIG from "@/config/index.js";
import router from "@/router/index.js";
export default {
    name: "permissionAdd",
    data(){
        return {
            addPermissionForm: {
                permissionName: null,
                permissionContent: null
            },
            validateRules: {
                permissionName: [
                    { required: true, message: '请填写权限名称', trigger: 'blur' }
                ],
                permissionContent: [
                    { required: true, message: '请填写权限概述', trigger: 'blur' }
                ]
            }
        };
    },
    methods: {
        addPermission(formName){
            let flag = true;
            this.$refs[formName].validate((valid) => {
                if (!valid) {
                    flag = false;
                    return false;
                }
            });
            if (!flag) {
                return;
            }
            let addPermissionData = {
                permissionsName: this.addPermissionForm.permissionName,
                permissionsContent: this.addPermissionForm.permissionContent
            };
            this.$http.post(CONFIG.HOST + '/users/addPermissions', addPermissionData).then((response)=>{
                let result = response.body;
                if (result && result.status === 1) {
                    this.$notify.success({
                        message: '【营销平台】权限创建成功'
                    });
                    this.clearPermissionData();
                    router.push({
                        name: 'permissionsList'
                    });
                } else {
                    this.$notify.error({
                        message: result.message
                    });
                }
            },(response)=>{
                console.log(response);
            });
        },
        clearPermissionData(){
            this.addPermissionForm.permissionName = null;
            this.addPermissionForm.permissionContent = null;
        }
    }
};
</script>
<style lang="less">
    .permissionAdd{
        width: 98%;
        margin: 0 auto;
        .bread-nav{
            margin: 20px 0;
        }
    }  
</style>


// WEBPACK FOOTER //
// Add.vue?326b02b8